import TomSelect from 'tom-select';

// Select2 used to be attached by class name, and most of those classes come
// from HtmlHelper attributes, so the same hooks and options are kept here.
// The first matching rule wins.
const rules = [
  ['.locations', { placeholder: 'Select locations', maxItems: 8 }],
  ['.productUpgrades', { placeholder: 'Select upgrades' }],
  ['.siteId', { placeholder: 'Select site' }],
  ['.recruitersforJobSelection', { placeholder: 'Select Recruiters' }],
  ['.locationsforJobSelection', { placeholder: 'Select Locations' }],
  ['.js-example-tags', { create: true }],
  ['.select2, .multiple-select2', {}],
];

// data-placeholder and data-allow-clear work as they did with Select2.
export function enhanceSelect(select, options = {}) {
  if (select.tomselect) {
    return select.tomselect;
  }

  const plugins = [];

  if (select.multiple) plugins.push('remove_button');
  if (select.dataset.allowClear === 'true') plugins.push('clear_button');

  return new TomSelect(select, {
    allowEmptyOption: true,
    maxOptions: null,
    plugins,
    ...(select.dataset.placeholder && { placeholder: select.dataset.placeholder }),
    ...options,
  });
}

export function enhanceSelects(root = document) {
  for (const [selector, options] of rules) {
    root.querySelectorAll(`select:is(${selector})`).forEach((select) => enhanceSelect(select, options));
  }
}
